import {Component,EventEmitter,Input,Output} from "@angular/core";
import {Adresse} from "../../../../domain/profil/adresse";
import {LieuParam} from "@domain/common/lieu/lieu-param";

/**
 * Composant gérant l'affichage de la liste des adresses
 */
@Component({
    selector: 'adresse-list',
    host: {'data-test-id': 'adresse-list'},
    templateUrl: './lieu-adresse-list.component.html',
})
export class LieuAdresseListComponent {

    /** Event émis lors de la sélection d'une adresse */
    @Output() onAdresseSelect = new EventEmitter<Adresse>();

    /** Liste des adresses pour les lieux OD / OT */
    @Input() listeAdresse: Array<Adresse>;

    /** Paramétrage du lieu */
    @Input() lieuParam: LieuParam;

    /**
     * Selection d'une adresse dans la liste
     */
    selectAdresse(adresse: Adresse): void {
        this.onAdresseSelect.emit(adresse);
    }
}
